
import Vue from "vue";
import { teamTags } from "@/config/teamTags";
import { mapState } from "vuex";
import { TeamTag } from "@/types";

export default Vue.extend({
  computed: {
    ...mapState("auth", ["user"]),
    teamTag(): TeamTag {
      return teamTags[this.$route.path.split("/")[1]];
    },
    userInitials(): string {
      return this.user
        ? this.user.name
          .split(" ")
          .map((n: any) => n[0])
          .join("")
        : "";
    },
  },
  methods: {
    redirectToSlack(teamTag: TeamTag) {
      const textElem = document.createElement("textarea");
      textElem.innerHTML = `@${teamTag.mention}`;
      document.body.appendChild(textElem);
      textElem.select();
      document.execCommand("copy");
      navigator.clipboard.writeText(textElem.value);
      document.body.removeChild(textElem);
      window.open(teamTag.channel, "_blank");
    },
  },
});
